export function getUrlWithoutQueryParams(): string {
  const location = window.location;
  return location.protocol + '//' + location.host + location.pathname
}
